import React, { useEffect, useState } from 'react';

import type { TopTagResponse } from '@schibsted/frapi-schema';

import { console } from '../../../../core/system/console/index.js';
import { sectionMappings } from '../../layouts/front/sectionHelpers.js';
import { makeTagTitle } from '../articles/helpers.js';
import { LinkWithPulse } from '../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';

interface TopTagsProps {
  section: string;
}

const PINNED_TAGS = [
  { id: '8e195e54-6fd6-4f1e-8234-d687f11f877b', title: 'Vink/område/Bergen' },
  {
    id: '69402a87-0843-487f-b4cc-7483a2a8eeae',
    title: 'Vink/område/Trondheim',
  },
];

export const TopTags: React.FC<TopTagsProps> = ({ section }) => {
  const [topTags, setTopTags] = useState<TopTagResponse>();

  useEffect(() => {
    (async () => {
      try {
        const sectionId = sectionMappings[section]?.sectionId;
        if (sectionId) {
          const res = await fetch(
            `/api/top-tags?sectionIds=${sectionMappings[section]?.sectionId}&tagTypes=machine&phrase=vink&limit=15`,
          );
          const json = await res.json();
          setTopTags(json);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [section]);

  return (
    <div className="top-tag-container">
      <h2 className="top-tag-title">Mye brukt:</h2>
      <div className="top-tags">
        {[
          ...PINNED_TAGS,
          ...(topTags?.items ?? []).filter(
            (t) => !PINNED_TAGS.some((pinned) => pinned.id === t.id),
          ),
        ].map((t) => {
          const tagTitle = makeTagTitle(t.title);

          return (
            <LinkWithPulse
              objectId={`top-tag:${section}`}
              name={`click top tag: ${tagTitle}`}
              // TODO: Tag props needed?
              custom={{
                tagId: t.id,
                tagTitle: t.title,
              }}
              className="regular regular-tag"
              key={t.id}
              href={`/samling/${section}/${t.id}`}
            >
              {tagTitle}
            </LinkWithPulse>
          );
        })}
      </div>
    </div>
  );
};
